import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["controlled"]

  static values = {
    displayOnce: { type: Boolean, default: false },
    identifier: String,
  }

  connect() {
    if (this.displayOnceValue && this.isDismissed()) {
      this.element.remove()
    }
  }

  controlledElement() {
    if (this.hasControlledTarget) {
      return this.controlledTarget
    } else {
      return this.element
    }
  }

  hide() {
    if (this.displayOnceValue) {
      this.markDismissed()
    }

    this.controlledElement().classList.add("hidden")
  }

  show() {
    this.controlledElement().classList.remove("hidden")
  }

  toggle(event) {
    if (event.target.checked) {
      this.show()
    } else {
      this.hide()
    }
  }

  isDismissed() {
    if (!this.hasIdentifierValue) return false
    return localStorage.getItem(this.storageKey()) === "true"
  }

  markDismissed() {
    if (!this.hasIdentifierValue) return
    localStorage.setItem(this.storageKey(), "true")
  }

  storageKey() {
    return `simple-hide:${this.identifierValue}`
  }
}
